import React from 'react'

const TermsOfService = props => {
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="Generator" content="Microsoft Word 15 (filtered)" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n<!--\n /* Font Definitions */\n@font-face\n\t{font-family:Arial;\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:"Arial Unicode MS";\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:"Helvetica Neue";\n\tpanose-1:2 0 5 3 0 0 0 2 0 4;}\n /* Style Definitions */\np.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tborder:none;}\np.MsoFooter, li.MsoFooter, div.MsoFooter\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Arial",sans-serif;\n\tcolor:black;\n\tborder:none;}\nspan.MsoPageNumber\n\t{color:black;\n\tfont-style:none;}\np.MsoListBullet, li.MsoListBullet, div.MsoListBullet\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Arial",sans-serif;\n\tcolor:black;\n\tborder:none;}\na:link, span.MsoHyperlink\n\t{text-decoration:underline;}\na:visited, span.MsoHyperlinkFollowed\n\t{color:fuchsia;\n\ttext-decoration:underline;}\np.HeaderFooter, li.HeaderFooter, div.HeaderFooter\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Helvetica Neue",sans-serif;\n\tcolor:black;\n\tborder:none;}\np.DocumentTitle, li.DocumentTitle, div.DocumentTitle\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:12.0pt;\n\tmargin-left:0in;\n\ttext-align:center;\n\tfont-size:16.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;\n\tfont-weight:bold;}\np.Paragraph, li.Paragraph, div.Paragraph\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\np.BulletList1, li.BulletList1, div.BulletList1\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\nspan.Hyperlink0\n\t{color:#1F497D;\n\tfont-style:none;\n\ttext-decoration:none;}\np.BodyA, li.BodyA, div.BodyA\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\np.Default, li.Default, div.Default\n\t{margin-top:8.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Helvetica Neue",sans-serif;\n\tcolor:black;\n\tborder:none;}\n.MsoChpDefault\n\t{font-size:10.0pt;\n\tborder:none;}\n /* Page Definitions */\n@page WordSection1\n\t{size:8.5in 11.0in;\n\tmargin:1.0in 1.0in 1.0in 1.0in;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\nol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n'
        }}
      />
      <div className="WordSection1">
        <p className="DocumentTitle">
          <span id="a1051406">
            <span className="NoneA">Website Terms of Use</span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">Last Modified:&nbsp; 18 July 2020</span>
        </p>
        <p className="Paragraph">
          <span id="a891809">
            <b>
              <u>
                <span style={{ textDecoration: 'none' }}>&nbsp;</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Acceptance of the Terms of Use</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051407">
            <span className="NoneA">These terms of use are entered into by and between you and Zoodiker, Inc. ("</span>
            <b>Zoodiker</b>
            <span className="NoneA">," "</span>
            <b>we</b>
            <span className="NoneA">," "</span>
            <b>our</b>
            <span className="NoneA">," or "</span>
            <b>us</b>
            <span className="NoneA">
              "). The following terms and conditions, together with our <a href="/privacy-policy">Privacy Policy</a> and
              Copyright Policy (collectively "
            </span>
            <b>Terms of Use</b>
            <span className="NoneA">
              ") govern your access to and use of zoodiker.com, including any content, functionality, and services
              offered on or through zoodiker.com and/or a Zoodiker application for a smart device, now existing or in
              the future (collectively, the "
            </span>
            <b>Website</b>
            <span className="NoneA">"), whether as a guest or a registered user.</span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051408">
            <span className="NoneA">Please read the Terms of Use carefully before you start to use the Website. </span>
            <b>
              <span style={{ background: 'transparent' }}>By clicking to accept or agree to the Terms of Use,</span> you
              agree to be bound and abide by these Terms of Use.
            </b>
            <span className="NoneA">
              {' '}
              If you do not want to agree to these Terms of Use, you must not access or use the Website.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a1051409">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Your Age</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            This Website is offered and available to users who are 18 years of age or older. By using this Website, you
            represent and warrant that you are of legal age to form a binding contract with Zoodiker and meet all of the
            foregoing eligibility requirements. If you do not meet all of these requirements, you must not access or use
            the Website.
          </span>
          <span className="NoneA">
            &nbsp; If we learn that you are under the age of 18 or you are acting on behalf of someone under the age of
            18, we will terminate your account.
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a456309">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Changes to the Terms of Use</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051480">
            <span className="NoneA">
              We may revise and update these Terms of Use from time to time in our sole discretion. All changes are
              effective immediately when we post them.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051411">
            <span className="NoneA">
              Your continued use of the Website following the posting of revised Terms of Use means that you accept and
              agree to the changes. You are expected to check this page from time to time so you are aware of any
              changes, as they are binding on you.{' '}
            </span>
          </span>
          <span id="a1004439" />
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Accessing the Website and Account Security</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051412">
            <span className="NoneA">
              We reserve the right to withdraw or amend this Website, and any service or material we provide on the
              Website, in our sole discretion without notice. We will not be liable if for any reason all or any part of
              the Website, including an Author’s Work, is unavailable at any time or for any period. From time to time,
              we may restrict access to some parts of the Website, or the entire Website, to users, including registered
              users.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051413">
            <span className="NoneA">You are responsible for both:</span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Making all arrangements necessary for you to have access to the Website.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Ensuring that all persons who access the Website through your internet connection are aware of these Terms
            of Use and comply with them.
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051414">
            <span className="NoneA">
              To access the Website or some of the features it offers, you may be asked to provide certain registration
              details or other information. It is a condition of your use of the Website that all the information you
              provide on the Website is correct, current, and complete. You agree that all information you provide to
              register with, access, or use this Website are governed by our{' '}
            </span>
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="NoneA"> </span>
            <span className="NoneA">
              {' '}
              and you consent to all actions we take with respect to your information consistent with our{' '}
              <a href="/privacy-policy">Privacy Policy</a>.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051415">
            <span className="NoneA">
              If you choose a user name, password, or any other piece of information as part of our security procedures,
              you must treat such information as confidential, and you must not disclose it to any other person or
              entity. You also acknowledge that your account is personal to you and agree not to provide any other
              person with access to this Website or portions of it using your user name, password, or other security
              information. You agree to notify us immediately of any unauthorized access to or use of your user name or
              password or any other breach of security. You also agree to ensure that you exit from your account at the
              end of each session. You should use particular caution when accessing your account from a public or shared
              computer so that others are not able to view or record your password or other personal information.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051416">
            <span className="NoneA">
              We have the right to disable any user name, password, or other identifier at any time in our sole
              discretion for any or no reason, including if, in our opinion, you have violated any provision of these
              Terms of Use.
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a342778">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Prohibited Uses</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051424">
            <span className="NoneA">
              You may use the Website only for lawful purposes and in accordance with these Terms of Use. You agree not
              to use the Website:
            </span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            In any way that violates any applicable federal, state, local, or international law or regulation
            (including, without limitation, any laws regarding the export of data or software to and from the US or
            other countries).{' '}
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them
            to inappropriate content, asking for personally identifiable information, or otherwise.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            To send, knowingly receive, upload, download, use, or re-use any material that does not comply with the{' '}
          </span>
          <span style={{ color: '#1F497D' }}>Content Standards</span>
          <span className="NoneA"> set out in these Terms of Use.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail,"
            "chain letter," "spam," or any other similar solicitation.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            To impersonate or attempt to impersonate Zoodiker, a Zoodiker employee, another user, or any other person or
            entity (including, without limitation, by using email addresses or screen names associated with any of the
            foregoing.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website, or
            which, as determined by us, may harm Zoodiker or users of the Website, or expose them to liability.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">To compete (directly or indirectly) with the Website.</span>
        </p>
        <p className="Paragraph">
          <span id="a1051425">
            <span className="NoneA">Additionally, you agree not to:</span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Steal any content from the Website, whether our content or a third party’s content or claim authorship of
            any material not created by you.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Use the Website in any manner that could disable, overburden, damage, or impair the site or interfere with
            any other party's use of the Website, including their ability to engage in real time activities through the
            Website.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Use any robot, spider, or other automatic device, process, or means to access the Website for any purpose,
            including monitoring or copying any of the material on the Website.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Use any manual process to monitor or copy any of the material on the Website, or for any other purpose not
            expressly authorized in these Terms of Use, without our prior written consent.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Use any device, software, or routine that interferes with the proper working of the Website.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Introduce any viruses, Trojan horses, worms, logic bombs, code, films, programs or other material that is
            malicious or technologically harmful.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Website, the
            server on which the Website is stored, or any server, computer, or database connected to the Website.{' '}
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Attack the Website via a denial-of-service attack or a distributed denial-of-service attack.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Otherwise attempt to interfere with the proper working of the Website.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in' }}>
          &nbsp;
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a583166">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>User Contributions</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051427">
            <span className="NoneA">
              The Website contains a platform for user submissions, mainly in the form of Works and Feedback.&nbsp; “
            </span>
            <b>Works</b>
            <span className="NoneA">” are original stories, screenplays, poetry, and other narrative writings. “</span>
            <b>Feedback</b>
            <span className="NoneA">
              ” are comments, evaluations, critiques, opinions, and suggestions responsive to a particular Work.&nbsp;
              Content or materials on the Website’s message boards, chat rooms, and other interactive features
              (collectively, "
            </span>
            <b>Interactive Services</b>
            <span className="NoneA">
              ") where users post, submit, publish, display, or transmit to other users or other persons (hereinafter, "
            </span>
            <b>post</b>
            <span className="NoneA">") are also deemed Feedback. Work and Feedback are collectively deemed "</span>
            <b>User Contributions</b>
            <span className="NoneA">".</span>
          </span>
          <span className="NoneA">&nbsp; </span>
          <span id="a1051428" />
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            A user may either be an “Author” or a “Reader”, depending on the context.&nbsp; The “
          </span>
          <b>Author”</b>
          <span className="NoneA">
            {' '}
            is the creator (or co-creator) of a Work. When a user posts a Feedback, such user is a “
          </span>
          <b>Reader”</b>
          <span className="NoneA">.&nbsp; </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            An Author can allow access to its Work to all Readers or restrict access to selected Readers.&nbsp; Unless
            necessitated by extenuating circumstances, Zoodiker does not compel an Author to provide access to its
            Work.&nbsp; However, all users who have access to an Author’s Work have access to&nbsp;&nbsp; Reader
            Feedback.&nbsp; The Author cannot selectively restrict access to the Feedback except by restricting
            readership of its Work.
          </span>
        </p>
        <p className="Paragraph">
          <b>
            Zoodiker makes no representation or warranty that a Work or Feedback will be restricted, accessed, or
            displayed in accordance with the Author’s preference.&nbsp; Authors and Readers post their Work or Feedback
            at their own risk.
          </b>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ marginLeft: '.5in', textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>User Acknowledgement</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051430">
            <span className="NoneA">You represent and warrant that: </span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            You own or control all rights in and to the User Contributions. If a Work is co-written, you warrant that
            your partner(s) has consented to the posting.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">All of your User Contributions do and will comply with these Terms of Use. </span>
        </p>
        <p className="Paragraph">
          <span id="a1051431">
            <span className="NoneA">You understand and acknowledge that:</span>
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            You and the User Contributions must comply with the Content Standards set out in these Terms of Use.
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            You are responsible for any User Contributions you submit or contribute, and you, not Zoodiker, have full
            responsibility for such content, including its legality and appropriateness.
          </span>
          <span id="a1051432" />
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            We are not responsible or liable to any third party for the content (and any use thereof) of any User
            Contributions posted by you or any other user of the Website.{' '}
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Zoodiker does not currently provide file backup services of any kind. You will not be able to download a
            copy of your work, by design of the Website and as part of our keeping your files secure. You are
            responsible for the proper storage and backup of your data.
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Zoodiker may provide the Author the ability to download Feedback to its Work. </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            A Reader’s interactions, reactions, engagement, data, and meta-data related to its behaviors, and any
            response to inquiries, questions, or surveys by or on behalf of Zoodiker with respect to a Work (“
          </span>
          <b>User Analytics</b>
          <span className="NoneA">
            ”) is the property of Zoodiker.&nbsp; Zoodiker retains all rights, title, claims, and interest in User
            Analytics.&nbsp; Zoodiker may disclose User Analytics to other users or third parties at its own discretion.
            <br />
            <br />
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>
                Warning for User Contributions:&nbsp; May Contain Objectionable Content
              </span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051436">
            <span className="NoneA">
              User Contributions may include sensitive topics or language that may trigger a negative reaction or offend
              certain users (“
            </span>
            <b>Sensitive Content</b>
            <span className="NoneA">”) Sensitive Content may include:</span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Language that is defamatory, obscene, indecent, abusive, offensive, violent, hateful, inflammatory, or
            otherwise objectionable.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Language that depicts a sex scene, self –harm (e.g. suicide; eating disorder), and/or abuse (including but
            not limited to sexual, verbal, emotional, and physical abuse).
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Language that describes, advocates, or promotes illegal activity or an unlawful act.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Language that causes upset, annoyance, alarm, or anxiety.&nbsp; </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Users may opt to tag their own User Contributions for Sensitive Topics.&nbsp; Zoodiker does not moderate or
            vet for Sensitive Content.&nbsp; We cannot warrant that content without a tag is free of any Sensitive
            Content or that a tag is accurate or complete.&nbsp;{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Zoodiker disclaims any and all liability for any damage (including but not limited to any physical,
            emotional, and/or pecuniary damage) resulting from exposure to Sensitive Content.{' '}
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" style={{ marginLeft: '.5in' }}>
          <span id="a631763">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Content Standards for User Contributions</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            These content standards apply to any and all User Contributions and use of Interactive Services. User
            Contributions must in their entirety comply with all applicable federal, state, local, and international
            laws and regulations.{' '}
          </span>
        </p>
        <p className="Paragraph">
          <b>
            WORKS MUST BE ORIGINAL SUBMISSIONS BY THE AUTHOR (or CO-AUTHORS). ZOODIKER DOES NOT TOLERATE ANY
            INTELLECTUAL PROPERTY INFRINGEMENT.&nbsp;{' '}
          </b>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            User Contributions in the form Feedback must be kind, respectful, and civil.&nbsp; We will not tolerate any
            communication that is hateful, abusive, threatening, harassing, obscene, or indecent.&nbsp;{' '}
          </span>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            Zoodiker has zero tolerance for any action that puts users at personal risk.&nbsp; Users are absolutely
            prohibited from revealing personal information or personally identifying information about another person,
            such as but not limited to a person’s name, address, email address, or image.&nbsp;{' '}
            <b>
              Zoodiker assumes no liability for any person posting his/her own personal information or a third party’s
              personal information.
            </b>
          </span>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            Zoodiker encourages Authors to appropriately tag their Work for Sensitive Comment.&nbsp; While there is no
            obligation to do so, appropriate tagging may allow the desired audience to reach your Work.
          </span>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            Zoodiker does not allow for any User Contribution that advertises products or services unrelated to, or not
            authorized by us.&nbsp; If any User Contribution is reasonably believed to be spam, Zoodiker may remove such
            content free from any liability.
          </span>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>&nbsp;</span>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <b>
            <u>
              <span style={{ fontFamily: '"Times New Roman",serif', fontVariant: 'small-caps' }}>
                Reporting Violations of Content Standards
              </span>
            </u>
          </b>
        </p>
        <p className="MsoListBullet">
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            If you believe a user has violated these Terms of Use, contact us at admin@zoodiker.com to submit a
            report.&nbsp;{' '}
          </span>
        </p>
        <p className="Paragraph">
          <b>
            <u>
              <span style={{ textDecoration: 'none' }}>&nbsp;</span>
            </u>
          </b>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a1051401">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Intellectual Property Rights</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051417">&nbsp;</span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Our Rights </span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            The Website and its entire contents, features, and functionality (including but not limited to all
            information, software, text, displays, images, video, and audio, User Analytics, and the design, selection,
            and arrangement thereof) excluding Author Contributions are owned by the Zoodiker and are protected by
            United States and international copyright, trademark, patent, trade secret, and other intellectual property
            or proprietary rights laws.
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" style={{ marginLeft: '.5in' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Your Rights</span>
            </u>
          </b>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            You own all the rights to the Works that you create and post on the Website. However if the Work you post is
            not yours, then posting it on the Website does not make it yours or confer to you any rights in the content.{' '}
          </span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">&nbsp;</span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '1.0in', textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span style={{ fontVariant: 'small-caps' }}>(1) Transfer of Rights to Author</span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            You, as a Reader, hereby convey, transfer, and assign all worldwide rights, title, credit, and authorship in
            your Feedback to the Author of the Work.&nbsp;{' '}
          </span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          &nbsp;
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            (2){' '}
          </span>
          <span style={{ fontVariant: 'small-caps' }}>Transfer of Rights to Zoodiker</span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            By posting your content on the Website, you give us a worldwide, nonexclusive, royalty-free, and
            transferable license to publish your User Contribution on our Website , and any reasonably related actions
            (such as, but not limited to, storing, displaying, reformatting, and distributing your Work, Feedback,
            content, and materials).{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            To the extent any User Analytics is owned by you, you hereby assign, transfer, and convey all rights, title,
            claims, and interest in your User Analytics to Zoodiker.
          </span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          &nbsp;
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            (3){' '}
          </span>
          <span style={{ fontVariant: 'small-caps' }}>Your Responsibility for Your Content</span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          <span className="NoneA">
            You are responsible for the content and material you post. This means you assume all risks related to its
            publication and display, including someone else’s reliance on its accuracy and any claims relating to
            intellectual property or other legal rights.
          </span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          &nbsp;
        </p>
        <p className="Paragraph" style={{ marginLeft: '.5in' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Restrictions Based on Intellectual Property Rights</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051418">
            <span className="NoneA">
              You must not reproduce, distribute, modify, create derivative works of, use, publicly display, publicly
              perform, republish, download, store, or transmit any of the materials on our Website, whether our material
              or another user’s material, such as, but not limited to text, illustrations, photographs, video or audio
              sequences, and graphics, except as follows:
            </span>
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing
            those materials.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            You may store files that are automatically cached by your Web browser for display enhancement purposes.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            If we provide desktop, mobile, or other smart device applications for download, you may download a single
            copy to your smart device solely for your own personal, non-commercial use, provided you agree to be bound
            by our end user license agreement for such applications.
          </span>
          <span id="a1051419" />
        </p>
        <p className="BulletList1">
          <span className="NoneA">You must not</span>
          <span className="NoneA">
            delete or alter any copyright, trademark, or other proprietary rights notices from any material from this
            site.
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051422">
            <span className="NoneA">
              If you violate our or a third party’s intellectual property rights, your right to use the Website will
              stop immediately and you must, at our option, return or destroy any copies of the materials you have made.
              No right, title, or interest in or to the Website or any content on the Website is transferred to you, and
              all rights not expressly granted are reserved by Zoodiker. Any use of the Website not expressly permitted
              by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark, and other
              laws.
            </span>
          </span>
        </p>
        <p className="Paragraph" style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>
          &nbsp;
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a974177">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Trademark</span>
              </u>
            </b>
          </span>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}> Notices</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051423">
            <span className="NoneA">
              The Zoodiker Inc. name, the term Zoodiker, the Zoodiker logo, and all related names, logos, product and
              service names, designs, and slogans are trademarks of Zoodiker Inc. You must not use such marks without
              the prior written permission of the Zoodiker. All other names, logos, product and service names, designs,
              and slogans on this Website are the trademarks of their respective owners.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <b>
            <u>
              <span style={{ textDecoration: 'none' }}>&nbsp;</span>
            </u>
          </b>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>Our Rights and Responses to Enforce our Terms of Use</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span id="a1051433">
            <span className="NoneA">
              Where there may be a violation of our Terms of Use, we may take action.&nbsp;{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">We have the right to:</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Remove or refuse to post any User Contributions in our sole discretion.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Take any action with respect to any User Contribution that we deem necessary or appropriate in our sole
            discretion, including if we believe that such User Contribution violates the Terms of Use, including the
            Content Standards, infringes any intellectual property right or other right of any person or entity,
            threatens the personal safety of users of the Website or the public, or could create liability for the
            Zoodiker.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Disclose your identity or other information about you to any third party who claims that material posted by
            you violates their rights, including their intellectual property rights or their right to privacy.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Take appropriate legal action, including without limitation, referral to law enforcement, for any illegal or
            unauthorized use of the Website.{' '}
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Terminate or suspend your access to all or part of the Website for any violation of these Terms of Use or
            for any or no reason.
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051434">
            <span className="NoneA">
              Without limiting the foregoing, and without restriction, we will cooperate fully with any law enforcement
              authorities or court order requesting or directing us to disclose the identity or other information of
              anyone posting any materials on or through the Website. YOU WAIVE AND HOLD HARMLESS ZOODIKER AND ITS
              SERVICE PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY ZOODIKER AND ITS SERVICE PROVIDERS
              DURING, OR TAKEN AS A CONSEQUENCE OF, INVESTIGATIONS BY EITHER ZOODIKER OR LAW ENFORCEMENT AUTHORITIES.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051435">
            <b>
              <u>
                <span style={{ textDecoration: 'none' }}>&nbsp;</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ fontVariant: 'small-caps' }}>No Liability For User Contributions</span>
            </u>
          </b>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            We do not undertake to review materials before they are posted on the Website, and cannot ensure prompt
            removal of objectionable materials, whether or not they constitute Sensitive Content, after they have been
            posted. Accordingly, we assume no liability for any action or inaction regarding transmissions,
            communications, or content provided by any user or third party. We have no liability or responsibility to
            anyone for performance or nonperformance of enforcement activities.{' '}
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a165957">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Copyright Infringement</span>
              </u>
            </b>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051437">
            <span className="NoneA">
              If you believe that any User Contributions violate your copyright, please see our{' '}
            </span>
          </span>
          <a href="#a183966">
            <span className="Hyperlink0">
              <span style={{ color: 'black' }}>
                <span style={{ color: 'black' }}>Copyright Policy</span>
              </span>
            </span>
          </a>{' '}
          <span className="NoneA">
            instructions on sending us a notice of copyright infringement. It is the policy of Zoodiker to terminate the
            user accounts of first time or repeat infringers, at Zoodiker’s sole discretion.{' '}
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a641274">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Reliance on Information Posted</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051438">
            <span className="NoneA">
              The information presented on or through the Website is made available solely for general information
              purposes. We do not warrant the accuracy, completeness, or usefulness of this information. Any reliance
              you place on such information is strictly at your own risk. We disclaim all liability and responsibility
              arising from any reliance placed on such materials by you or any other visitor to the Website, or by
              anyone who may be informed of any of its contents.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051439">
            <span className="NoneA">
              This Website includes content provided by third parties, and may include materials provided by other
              users, bloggers, and third-party licensors, syndicators, aggregators, and/or reporting services. All user
              submissions, statements and/or opinions expressed in these materials, and all articles, responses to
              questions and other content, other than the content provided by Zoodiker, are solely the opinions and the
              responsibility of the person or entity providing those materials. These materials do not necessarily
              reflect the opinion of Zoodiker. We are not responsible, or liable to you or any third party, for the
              content or accuracy of any materials provided by any third parties.
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a908307">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Changes to the Website</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051440">
            <span className="NoneA">
              We may update the content on this Website from time to time, but its content is not necessarily complete
              or up-to-date. Any of the material on the Website may be out of date at any given time, and we are under
              no obligation to update such material.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            We are not responsible for User Contributions and provide no right of any kind with respect to a User
            Contribution, including a right of access.&nbsp;{' '}
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a212305">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>
                    Information About You and Your Visits to the Website
                  </span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051441">
            <span className="NoneA">
              All information we collect on this Website is subject to our <a href="/privacy-policy">Privacy Policy</a>
            </span>
            <span className="NoneA">
              . By using the Website, you consent to all actions taken by us with respect to your information in
              compliance with the <a href="/privacy-policy">Privacy Policy</a>.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a457429">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Links from the Website</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051450">
            <span className="NoneA">
              If the Website contains links to other sites and resources provided by third parties, these links are
              provided for your convenience only. This includes links contained in advertisements, including banner
              advertisements and sponsored links. We have no control over the contents of those sites or resources, and
              accept no responsibility for them or for any loss or damage that may arise from your use of them. If you
              decide to access any of the third-party websites linked to this Website, you do so entirely at your own
              risk and subject to the terms and conditions of use for such websites.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">&nbsp;</span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span className="None">
            <b>
              <u>
                <span style={{ fontVariant: 'small-caps' }}>Suggestions for Zoodiker</span>
              </u>
            </b>
          </span>
        </p>
        <p className="BodyA" style={{ marginTop: '6.0pt' }}>
          <span className="None">
            <span lang="DE">We </span>welcome ideas and suggestions to improve Zoodiker.&nbsp; If you submit ideas or
            materials to
            <span lang="DE">Zoodiker, </span>we make no assurances that your submission will be treated as confidential
            or proprietary.<span lang="DE">&nbsp; </span>All comments, suggestions, ideas, notes, drawings, concepts, or
            other information disclosed or offered to us by you regarding the Website, and any smart device
            applications, shall be deemed non-confidential and non-proprietary and shall become the exclusive property
            of Zoodiker Inc. without compensation. You understand that Zoodiker utilizes both internal and third party
            resources that may have developed or may in the future develop ideas identical or similar to your
            suggestions.&nbsp; In any event, you acknowledge and agree that <span lang="DE">Zoodiker</span>
            assumes no obligation of confidentiality or nondisclosure, express or implied by considering your feedback
            or suggestions. Without limitation, <span lang="DE">Zoodiker</span>
            shall exclusively own all now known or hereafter existing rights in and to your suggestions, and{' '}
            <span lang="DE">Zoodiker</span> shall be entitled to unrestricted use of your suggestions for any purpose
            whatsoever, commercial or otherwise without any form of compensation.
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a107208">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Disclaimer of Warranties</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051452">
            <span className="NoneA">
              You understand that we cannot and do not guarantee or warrant that files that may be available for
              downloading from the internet or the Website will be free of viruses or other destructive code. You are
              responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements
              for anti-virus protection and accuracy of data input and output, and for maintaining a means external to
              our site for any reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY LAW, WE WILL NOT BE
              LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER
              TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA, OR
              OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
              WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051453">
            <span className="NoneA">
              YOUR USE OF THE WEBSITE, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE IS AT YOUR
              OWN RISK. THE WEBSITE, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON
              AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
              NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY OR REPRESENTATION WITH
              RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE WEBSITE.
              WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR
              WARRANTS THAT THE WEBSITE, ITS CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL BE
              ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE
              SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE WEBSITE OR ANY
              SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051454">
            <span className="NoneA">
              TO THE FULLEST EXTENT PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
              EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
              MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051455">
            <span className="NoneA">
              THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a136928">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Limitation on Liability</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COLLECTIVE LIABILITY OF THE COMPANY AND ITS
            SUBSIDIARIES AND AFFILIATES, AND THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, AND
            DIRECTORS, TO ANY PARTY (REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT, OR OTHERWISE) EXCEED
            THE AMOUNT YOU HAVE PAID TO THE COMPANY FOR YOUR SUBSCRIPTION PLAN IN THE LAST THREE MONTHS OUT OF WHICH
            LIABILITY AROSE.
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            The limitation of liability set out above does not apply to liability resulting from our gross negligence or
            willful misconduct.
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051458">
            <span className="NoneA">
              THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            <b>&nbsp;</b>
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a1051459">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Indemnification</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051460">
            <span className="NoneA">
              You agree to defend, indemnify, and hold harmless Zoodiker, its affiliates, licensors, and service
              providers, and its and their respective officers, directors, employees, contractors, agents, licensors,
              suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards,
              losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your
              violation of these Terms of Use or your use of the Website, including, but not limited to, your User
              Contributions, any use of the Website's content, services, and products other than as expressly authorized
              in these Terms of Use, or your use of any information obtained from the Website.
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a699054">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Governing Law and Jurisdiction</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051462">
            <span className="NoneA">
              All matters relating to the Website and these Terms of Use, and any dispute or claim arising therefrom or
              related thereto (in each case, including non-contractual disputes or claims), shall be governed by and
              construed in accordance with the internal laws of the State of California without giving effect to any
              choice or conflict of law provision or rule (whether of the State of California or any other
              jurisdiction).
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051463">
            <span className="NoneA">
              Any legal suit, action, or proceeding arising out of, or related to, these Terms of Use or the Website
              shall be instituted exclusively in the federal courts of the United States located in the City of Los
              Angeles and County of Los Angeles, although we retain the right to bring any suit, action, or proceeding
              against you for breach of these Terms of Use in your country of residence or any other relevant country.
              You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in
              such courts.
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a770723">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Arbitration</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051464">
            <span className="NoneA">
              At Zoodiker's sole discretion, it may require You to submit any disputes arising from these Terms of Use
              or use of the Website, including disputes arising from or concerning their interpretation, violation,
              invalidity, non-performance, or termination, to final and binding arbitration under the Rules of
              Arbitration of the American Arbitration Association applying{' '}
            </span>
          </span>
          <span className="NoneA">California law.</span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a772593">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Limitation on Time to File Claims</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051465">
            <span className="NoneA">
              ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE AGAINST ZOODIKER ARISING OUT OF OR RELATING TO THESE TERMS OF
              USE OR THE WEBSITE MUST BE COMMENCED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE,
              SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY BARRED.
            </span>
          </span>
          <span className="NoneA">
            <br />
            <br />
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a1051466">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Waiver and Severability</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051467">
            <span className="NoneA">
              No waiver by the Zoodiker of any term or condition set out in these Terms of Use shall be deemed a further
              or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure
              of the Zoodiker to assert a right or provision under these Terms of Use shall not constitute a waiver of
              such right or provision.
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051468">
            <span className="NoneA">
              If any provision of these Terms of Use is held by a court or other tribunal of competent jurisdiction to
              be invalid, illegal, or unenforceable for any reason, such provision shall be eliminated or limited to the
              minimum extent such that the remaining provisions of the Terms of Use will continue in full force and
              effect.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a361445">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps', background: 'transparent' }}>Entire Agreement</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051469">
            <span className="NoneA">
              The Terms of Use, our <a href="/privacy-policy">Privacy Policy</a>, and our Copyright Policy constitute
              the sole and entire agreement between you and Zoodiker regarding the Website and supersede all prior and
              contemporaneous understandings, agreements, representations, and warranties, both written and oral,
              regarding the Website.{' '}
            </span>
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a1051470">
            <span className="None">
              <b>
                <u>
                  <span style={{ fontVariant: 'small-caps' }}>Your Comments and Concerns</span>
                </u>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051471">
            <span className="NoneA">This website is operated by Zoodiker, Inc. </span>
          </span>
        </p>
        <p className="Paragraph">
          <span id="a1051472">
            <span className="NoneA">
              All notices of copyright infringement claims should be sent to the copyright agent designated in our{' '}
            </span>
          </span>
          <a href="#a183966">
            <span className="Hyperlink0">
              <span style={{ color: 'black' }}>
                <span style={{ color: 'black' }}>Copyright Policy</span>
              </span>
            </span>
          </a>{' '}
          <span className="NoneA">in the manner and by the means set out therein.</span>
        </p>
        <p className="Paragraph">
          <span id="a1051473">
            <span className="NoneA">
              All other feedback, comments, requests for technical support, and other communications relating to the
              Website should be directed to:{' '}
            </span>
          </span>
          <span className="NoneA">ADMIN@ZOODIKER.COM.</span>
        </p>
        <span className="None">
          <span style={{ fontSize: '16.0pt', fontFamily: '"Arial Unicode MS",sans-serif', color: 'black' }}>
            <br clear="all" style={{ pageBreakBefore: 'always' }} />
          </span>
        </span>
        <p className="DocumentTitle">&nbsp;</p>
        <p className="DocumentTitle">
          <span id="a183966">
            <span className="None">
              <span style={{ fontVariant: 'small-caps' }}>Copyright Policy</span>
            </span>
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a895037">
            <span className="None">
              <b>What is Copyright Infringement&nbsp;&nbsp; </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Infringement occurs when a work is reproduced, distributed, performed, publicly displayed, or made into a
            derivative work without permission of the author or creator.&nbsp;{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Below are some examples of copyright infringement.&nbsp; This list is not intended to be a complete list of
            infringing activity.
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Posting a work without attributing the work to the Author or creator when the Author or creator did not
            consent.
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Posting a work and giving credit to the Author or creator when the Author or creator did not consent.
          </span>
        </p>
        <p className="Paragraph" style={{ marginLeft: '.25in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Posting an adaption or slight alteration of a work when the Author or creator did not consent.
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span className="None">
            <b>&nbsp;</b>
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span className="None">
            <b>Reporting Claims of Copyright Infringement</b>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">Zoodiker, Inc. ("</span>
          <span className="None">
            <b>Zoodiker</b>
          </span>
          <span className="NoneA">," "</span>
          <span className="None">
            <b>we</b>
          </span>
          <span className="NoneA">," "</span>
          <span className="None">
            <b>our</b>
          </span>
          <span className="NoneA">," or "</span>
          <span className="None">
            <b>us</b>
          </span>
          <span className="NoneA">
            ") take claims of copyright infringement seriously. We will respond to notices of alleged copyright
            infringement that comply with applicable law. If you believe any materials accessible on or from this site
            (the "
          </span>
          <span className="None">
            <b>Website</b>
          </span>
          <span className="NoneA">
            ") infringe your copyright, you may request removal of those materials (or access to them) from the Website
            by submitting written notification to our copyright agent designated below. In accordance with the Online
            Copyright Infringement Liability Limitation Act of the Digital Millennium Copyright Act (17 U.S.C. § 512) ("
          </span>
          <span className="None">
            <b>DMCA</b>
          </span>
          <span className="NoneA">"), the written notice (the "</span>
          <span className="None">
            <b>DMCA Notice</b>
          </span>
          <span className="NoneA">") must include substantially the following:</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Your physical or electronic signature.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Identification of the copyrighted work you believe to have been infringed or, if the claim involves multiple
            works on the Website, a representative list of such works.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Identification of the material you believe to be infringing in a sufficiently precise manner to allow us to
            locate that material.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Adequate information by which we can contact you (including your name, postal address, telephone number,
            and, if available, email address).
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            A statement that you have a good faith belief that use of the copyrighted material is not authorized by the
            copyright owner, its agent, or the law.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">A statement that the information in the written notice is accurate.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            A statement, under penalty of perjury, that you are authorized to act on behalf of the copyright owner.
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">Our designated copyright agent to receive DMCA Notices is:</span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
        </p>
        <p className="Paragraph" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="NoneA">
            Honeah Sohail Mangione
            <br />
            <br />
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="NoneA">Ellenoff Grossman &amp; Schole LLP</span>
        </p>
        <p className="Default" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="None">
            <span style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>
              1345 Avenue of the Americas
            </span>
          </span>
        </p>
        <p className="Default" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="None">
            <span style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>New York, NY 10105</span>
          </span>
        </p>
        <p className="Default" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="None">
            <span lang="IT" style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>
              646-895-7238
            </span>
          </span>
        </p>
        <p className="Default" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="None">
            <span lang="IT" style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>
              copyright@egsllp.com
            </span>
          </span>
        </p>
        <p className="Default" align="center" style={{ marginTop: '0in', textAlign: 'center' }}>
          <span className="None">
            <span lang="IT" style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>
              &nbsp;
            </span>
          </span>
        </p>
        <p className="Default" style={{ marginTop: '0in' }}>
          <span className="None">
            <span lang="IT" style={{ fontFamily: '"Times New Roman",serif', background: 'transparent' }}>
              &nbsp;
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            If you fail to comply with all of the requirements of Section 512(c)(3) of the DMCA, your DMCA Notice may
            not be effective.
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Please be aware that if you knowingly materially misrepresent that material or activity on the Website is
            infringing your copyright, you may be held liable for damages (including costs and attorneys' fees) under
            Section 512(f) of the DMCA.
          </span>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <span id="a896360">
            <span className="None">
              <b>Counter Notification Procedures</b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            If you believe that material you posted on the Website was removed or access to it was disabled by mistake
            or misidentification, you may file a counter notification with us (a "
          </span>
          <span className="None">
            <b>Counter Notice</b>
          </span>
          <span className="NoneA">
            ") by submitting written notification to our copyright agent designated [above/below]. Pursuant to the DMCA,
            the Counter Notice must include substantially the following:
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">Your physical or electronic signature.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            An identification of the material that has been removed or to which access has been disabled and the
            location at which the material appeared before it was removed or access disabled.{' '}
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            Adequate information by which we can contact you (including your name, postal address, telephone number,
            and, if available, email address).
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            A statement under penalty of perjury by you that you have a good faith belief that the material identified
            above was removed or disabled as a result of a mistake or misidentification of the material to be removed or
            disabled.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="NoneA">
            A statement that you will consent to the jurisdiction of the Federal District Court for the judicial
            district in which your address is located (or if you reside outside the United States for any judicial
            district in which the Website may be found) and that you will accept service from the person (or an agent of
            that person) who provided the Website with the complaint at issue.
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">Our designated agent to receive Counter Notices is:</span>
        </p>
        <table
          className="MsoNormalTable"
          border={1}
          cellSpacing={0}
          cellPadding={0}
          width={468}
          style={{ marginLeft: '.3in', background: '#CED7E7', borderCollapse: 'collapse', border: 'none' }}
        >
          <tbody>
            <tr style={{ height: '90.5pt' }}>
              <td
                width={468}
                valign="top"
                style={{
                  width: '6.5in',
                  border: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '90.5pt'
                }}
              >
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">Honeah Sohail Mangione</span>
                </p>
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">Ellenoff Grossman &amp; Schole LLP</span>
                </p>
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">1345 Avenue of the Americas</span>
                </p>
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">New York City, NY 10105</span>
                </p>
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">646-895-7238</span>
                </p>
                <p
                  className="Paragraph"
                  align="center"
                  style={{ marginTop: '0in', textAlign: 'center', background: 'white' }}
                >
                  <span className="None">copyright@egsllp.com</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="Paragraph" style={{ marginLeft: '16.2pt', textIndent: '-16.2pt' }}>
          &nbsp;
        </p>
        <p className="Paragraph" style={{ marginLeft: '.15in', textIndent: '-.15in' }}>
          &nbsp;
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            The DMCA allows us to restore the removed content if the party filing the original DMCA Notice does not file
            a court action against you within ten business days of receiving the copy of your Counter Notice.
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            Please be aware that if you knowingly materially misrepresent that material or activity on the Website was
            removed or disabled by mistake or misidentification, you may be held liable for damages (including costs and
            attorneys' fees) under Section 512(f) of the DMCA.
          </span>
        </p>
        <p className="Paragraph">
          <span id="a184757">
            <span className="None">
              <b>
                <span style={{ fontVariant: 'small-caps' }}>Response to Infringement</span>
              </b>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="NoneA">
            It is our policy in appropriate circumstances to disable and/or terminate the accounts of users who infringe
            third party rights, irrespective of the extent of infringement.
          </span>
        </p>
      </div>
    </div>
  )
}

export default TermsOfService
